import React, {useState} from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {Spinner} from "react-bootstrap";
import {useSelector} from "react-redux";
import {toast} from "react-toastify";
import axios from "axios";

const MassSendClassificationsModal = ({show, setShow, reportType, filters, selectedRows, successfullCallback, sendClassifications}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [loading, setLoading] = useState(false);
    const [consoleLines, setConsoleLines] = useState([]);

    const handleFetch = async () => {
        setLoading(true);
        setConsoleLines([]);
        const consoleTemp = [];
        try {
            // Fetch existing MyData Report and get differences with current filters
            const requestData = {
                ...filters,
                classified: "classificationsDifference",
                company: company.id,
                reportType: reportType,
                forExport: true,
            }
            const reportResponse = await axios.post(`${process.env.REACT_APP_API_URL2}/report/fetch-mydata-report`, requestData, {
                headers: { "Content-Type": "application/json" },
            });
            if (reportResponse.data.status === "200") {
                // Save differences one by one
                if (reportResponse.data.data?.length === 0) {
                    toast.info("Δεν βρέθηκαν διαφορές.");
                } else {
                    let results = reportResponse.data?.data;
                    if(selectedRows?.length > 0) { //filter selected
                        if(selectedRows.length !== 1 || selectedRows[0] !== -1) { //select all
                            if(selectedRows.some((el) => el === -1)) { //exclude selected
                                results = results.filter((doc) => !selectedRows.filter((el) => el !== -1).includes(String(doc?.mark)));
                            } else { //include selected
                                results = results.filter((doc) => selectedRows.includes(String(doc?.mark)));
                            }
                        }
                    }
                    for (let res of results) {
                        const response = await sendClassifications(true, res);
                        consoleTemp.push(`${res.mark} : ${response.message}`);
                    }
                    successfullCallback();
                }
            } else {
                toast.error(reportResponse.data.message);
            }
        } catch (err) {
            console.log(err);
            toast.error("Σφάλμα κατά την εκτέλεση διαδικασίας.");
        }
        setLoading(false);
        setConsoleLines(consoleTemp);
    }

    return (
        <React.Fragment>
            <Modal show={show} onHide={() => setShow(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Μαζική αποστολή χαρακτηρισμών</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Η μαζική αποστολή χαρακτηρισμών θα αποστείλει τους χαρακτηρισμούς που είναι αποθηκευμένοι στο ERP αλλά έχουν διαφορά με το MyData.

                    {consoleLines.length > 0 && (
                        <React.Fragment>
                            <h5 style={{textAlign: "center"}} className={"mt-2"}>Κονσόλα:</h5>
                            <div style={{height: "300px", overflowY: "scroll", border: "1px solid gray", padding: "5px"}}
                                 className={"mb-3"}>
                                {consoleLines.length > 0 && consoleLines.map((line) => (
                                    <span>{line}<br/></span>
                                ))}
                            </div>
                        </React.Fragment>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => handleFetch()} disabled={loading}>
                        Αποστολή {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default MassSendClassificationsModal
